import React from "react";

const Contact = () => {
  const handlePhoneClick = () => {
    if (window.gtag) {
      window.gtag("config", "AW-18343552397/3FAKCIr6l9ccEI3L8apE", {
        phone_conversion_number: "1-877-991-0909",
      });
    }
  };
  return (
    <main className="w-full bg-[#f4f7fb] font-sans text-slate-800 overflow-hidden">
      {/* SECTION 1: Contact Hero */}
      <section className="mx-auto px-4 sm:px-6 lg:px-8 pt-12 lg:pt-16 pb-12 lg:pb-16 border-b border-slate-200">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Column: Heading & Buttons */}
          <div className="pr-0 lg:pr-8">
            <div className="flex items-center gap-2 mb-4">
              <svg
                className="w-3 h-3 text-[#e32b22]"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M10 13l-5-5 5-5v10z" />
              </svg>
              <span className="text-[#e32b22] text-xs font-bold uppercase tracking-widest">
                Contact USACarBooking
              </span>
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#091b3e] leading-tight mb-6">
              Need help with your car rental reservation?
            </h1>
            <p className="text-slate-600 text-base sm:text-lg leading-relaxed mb-8">
              Contact USACarBooking for reservation assistance, itinerary
              changes, cancellation requests where permitted, and general
              booking support.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:+18779910909"
                className="flex items-center justify-center gap-2 bg-[#e32b22] hover:bg-red-700 text-white font-bold py-3 px-6 rounded-full transition-colors w-full sm:w-auto text-sm tracking-wide"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                CALL 1-877-991-0909
              </a>
              <a
                href="mailto:info@USACarBooking.com"
                className="flex items-center justify-center gap-2 bg-white hover:bg-slate-50 text-[#091b3e] font-bold py-3 px-6 rounded-full border border-slate-300 transition-colors w-full sm:w-auto text-sm tracking-wide"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                EMAIL US
              </a>
            </div>
          </div>

          {/* Right Column: Contact Cards */}
          <div className="flex flex-col gap-4">
            {/* Card 1 */}
            <div className="bg-white rounded-2xl shadow-sm p-6 flex items-start gap-4 border border-slate-100">
              <div className="bg-[#091b3e] text-white p-3 rounded-lg flex-shrink-0 mt-1">
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
              </div>
              <div>
                <h3 className="text-[#091b3e] font-bold text-lg leading-tight mb-1">
                  Call reservation support
                </h3>
                <p className="text-slate-500 text-sm mb-2">
                  Speak with us about rental requests, trip details, and booking
                  assistance.
                </p>
                <a
                  href="tel:+18779910909"
                  onClick={handlePhoneClick}
                  className="text-[#e32b22] font-bold text-sm hover:underline"
                >
                  1-877-991-0909
                </a>
              </div>
            </div>

            {/* Card 2 */}
            <div className="bg-white rounded-2xl shadow-sm p-6 flex items-start gap-4 border border-slate-100">
              <div className="bg-[#091b3e] text-white p-3 rounded-lg flex-shrink-0 mt-1">
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <div>
                <h3 className="text-[#091b3e] font-bold text-lg leading-tight mb-1">
                  Email USACarBooking
                </h3>
                <p className="text-slate-500 text-sm mb-2">
                  Send your rental question or reservation support request by
                  email.
                </p>
                <a
                  href="mailto:reservations@USACarBooking.com"
                  className="text-[#e32b22] font-bold text-sm hover:underline break-all"
                >
                  reservations@USACarBooking.com
                </a>
              </div>
            </div>

            {/* Card 3 */}
            <div className="bg-white rounded-2xl shadow-sm p-6 flex items-start gap-4 border border-slate-100">
              <div className="bg-[#091b3e] text-white p-3 rounded-lg flex-shrink-0 mt-1">
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              </div>
              <div>
                <h3 className="text-[#091b3e] font-bold text-lg leading-tight mb-1">
                  Business address
                </h3>
                <p className="text-slate-500 text-sm mb-2">
                  Centralized contact configuration address for this static
                  website.
                </p>
                <span className="text-[#e32b22] font-bold text-sm uppercase">
                  {/* 2730 Cedarview Road, Ottawa, Ontario, K2J7J8, Canada */}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2: Form Area */}
      <section className="mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-start">
          {/* Form Area Left: Text and small info cards */}
          <div className="lg:col-span-5 pr-0 lg:pr-8">
            <div className="flex items-center gap-2 mb-4">
              <svg
                className="w-3 h-3 text-[#e32b22]"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M10 13l-5-5 5-5v10z" />
              </svg>
              <span className="text-[#e32b22] text-xs font-bold uppercase tracking-widest">
                Send your rental details
              </span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-[#091b3e] leading-tight mb-6">
              Tell us what you need for your trip
            </h2>
            <p className="text-slate-600 text-base leading-relaxed mb-8">
              Share your pickup location, dates, time, and preferred vehicle
              type. This static form keeps the same behavior while presenting
              the request in a cleaner layout.
            </p>

            <div className="flex flex-col gap-4">
              {/* Info Card 1 */}
              <div className="bg-white rounded-2xl shadow-sm p-6 flex items-start gap-4 border border-slate-100">
                <div className="bg-[#e32b22] text-white p-3 rounded-lg flex-shrink-0 mt-1">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-[#091b3e] font-bold text-base leading-tight mb-2">
                    Support availability
                  </h3>
                  <p className="text-slate-500 text-xs leading-relaxed">
                    You can call or email us for car rental enquiry assistance.
                    Response time may vary depending on request volume.
                  </p>
                </div>
              </div>

              {/* Info Card 2 */}
              <div className="bg-white rounded-2xl shadow-sm p-6 flex items-start gap-4 border border-slate-100">
                <div className="bg-[#091b3e] text-white p-3 rounded-lg flex-shrink-0 mt-1">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-[#091b3e] font-bold text-base leading-tight mb-2">
                    USACarBooking.com
                  </h3>
                  <p className="text-slate-500 text-xs leading-relaxed">
                    USACarBooking is an independent car rental enquiry
                    assistance service and is not officially connected to any
                    specific rental company.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Form Area Right: The Contact Form */}
          <div className="lg:col-span-7 bg-white rounded-3xl shadow-xl p-6 sm:p-8 border border-slate-100">
            <form className="space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {/* Full Name */}
                <div>
                  <label className="block text-[#091b3e] text-sm font-bold mb-2">
                    Full Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter your name"
                    className="w-full bg-slate-50 border border-slate-200 text-slate-800 text-sm rounded-lg focus:ring-[#e32b22] focus:border-[#e32b22] block p-3 outline-none transition-colors"
                  />
                </div>
                {/* Phone Number */}
                <div>
                  <label className="block text-[#091b3e] text-sm font-bold mb-2">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    placeholder="Enter phone number"
                    className="w-full bg-slate-50 border border-slate-200 text-slate-800 text-sm rounded-lg focus:ring-[#e32b22] focus:border-[#e32b22] block p-3 outline-none transition-colors"
                  />
                </div>
                {/* Email Address */}
                <div>
                  <label className="block text-[#091b3e] text-sm font-bold mb-2">
                    Email Address
                  </label>
                  <input
                    type="email"
                    placeholder="Enter email address"
                    className="w-full bg-slate-50 border border-slate-200 text-slate-800 text-sm rounded-lg focus:ring-[#e32b22] focus:border-[#e32b22] block p-3 outline-none transition-colors"
                  />
                </div>
                {/* Pickup Location */}
                <div>
                  <label className="block text-[#091b3e] text-sm font-bold mb-2">
                    Pickup Location
                  </label>
                  <input
                    type="text"
                    placeholder="City or airport"
                    className="w-full bg-slate-50 border border-slate-200 text-slate-800 text-sm rounded-lg focus:ring-[#e32b22] focus:border-[#e32b22] block p-3 outline-none transition-colors"
                  />
                </div>
                {/* Pickup Date */}
                <div>
                  <label className="block text-[#091b3e] text-sm font-bold mb-2 flex items-center gap-2">
                    <svg
                      className="w-4 h-4 text-[#e32b22]"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      ></path>
                    </svg>
                    Pickup Date
                  </label>
                  <input
                    type="date"
                    className="w-full bg-slate-50 border border-slate-200 text-slate-500 text-sm rounded-lg focus:ring-[#e32b22] focus:border-[#e32b22] block p-3 outline-none transition-colors"
                  />
                </div>
                {/* Vehicle Type */}
                <div>
                  <label className="block text-[#091b3e] text-sm font-bold mb-2 flex items-center gap-2">
                    <svg
                      className="w-4 h-4 text-[#e32b22]"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      ></path>
                    </svg>
                    Vehicle Type
                  </label>
                  <select className="w-full bg-slate-50 border border-slate-200 text-slate-500 text-sm rounded-lg focus:ring-[#e32b22] focus:border-[#e32b22] block p-3 outline-none transition-colors appearance-none">
                    <option>Select vehicle type</option>
                    <option>Economy</option>
                    <option>Compact</option>
                    <option>Midsize / Standard</option>
                    <option>Full Size</option>
                    <option>SUV</option>
                    <option>Minivan</option>
                  </select>
                </div>
              </div>

              {/* Message */}
              <div>
                <label className="block text-[#091b3e] text-sm font-bold mb-2">
                  Message
                </label>
                <textarea
                  rows="4"
                  placeholder="Tell us about your rental request..."
                  className="w-full bg-slate-50 border border-slate-200 text-slate-800 text-sm rounded-lg focus:ring-[#e32b22] focus:border-[#e32b22] block p-3 outline-none transition-colors resize-y"
                ></textarea>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-[#e32b22] hover:bg-red-700 text-white font-bold py-4 px-6 rounded-xl transition-colors tracking-wide text-sm"
              >
                SUBMIT RENTAL REQUEST
              </button>

              {/* Disclaimer */}
              <p className="text-center text-slate-400 text-xs">
                By submitting this form, you request contact from our support
                team regarding your car rental enquiry.
              </p>
            </form>
          </div>
        </div>
      </section>

      {/* SECTION 3: Bottom Features */}
      <section className="mx-auto px-4 sm:px-6 lg:px-8 pb-16 lg:pb-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Feature 1 */}
          <div className="bg-white rounded-2xl shadow-sm p-6 sm:p-8 flex flex-col gap-4 border border-slate-100 hover:shadow-md transition-shadow">
            <div className="bg-[#e32b22] text-white p-3 rounded-lg w-12 h-12 flex items-center justify-center">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
                />
              </svg>
            </div>
            <h3 className="text-[#091b3e] font-bold text-lg leading-tight">
              Reservation assistance
            </h3>
            <p className="text-slate-500 text-sm leading-relaxed">
              Share pickup details, dates, times, and preferred vehicle
              category.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="bg-white rounded-2xl shadow-sm p-6 sm:p-8 flex flex-col gap-4 border border-slate-100 hover:shadow-md transition-shadow">
            <div className="bg-[#e32b22] text-white p-3 rounded-lg w-12 h-12 flex items-center justify-center">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                />
              </svg>
            </div>
            <h3 className="text-[#091b3e] font-bold text-lg leading-tight">
              Itinerary change support
            </h3>
            <p className="text-slate-500 text-sm leading-relaxed">
              Contact us when your travel details change and you need guidance.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="bg-white rounded-2xl shadow-sm p-6 sm:p-8 flex flex-col gap-4 border border-slate-100 hover:shadow-md transition-shadow">
            <div className="bg-[#e32b22] text-white p-3 rounded-lg w-12 h-12 flex items-center justify-center">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h3 className="text-[#091b3e] font-bold text-lg leading-tight">
              Cancellation questions
            </h3>
            <p className="text-slate-500 text-sm leading-relaxed">
              Ask about cancellation support where permitted by the applicable
              provider.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
